export default __webpack_public_path__ + "media/components/FeaturedImage/background-1129965568ae2158f1d7ce5a5d4117b6.jpg";